/*
 * @Author: cc
 * @LastEditTime: 2022-06-17 17:21:06
 */
import { useEffect, useState } from "react";
// import { IsPc } from "../utils/index";
import Style from "./index.module.scss"
import "moment/locale/zh-cn";
import { useLocation, useHistory } from "react-router-dom";
// import logo from "../../../img/logo.png"
import { IsPC } from "../../../utils/index";
import { Button, List, Modal, Tabs, TabsProps, message } from "antd"
import { post, get } from "../../../component/fetch"
import store from "src/reducers";
import Login from "../../../page/component/login"
import SignUp from "../../../page/component/signupModal"
import { QrcodeOutlined,PlayCircleOutlined } from "@ant-design/icons"
import { Loading } from "antd-mobile";
import moment from "moment";
// let playInfo = localStorage.getItem('playInfo')
// let siteid = playInfo ? JSON.parse(playInfo).liveAccount : '';
const { BASE_URL, PUBLIC_URL } = process.env
let newWindow = window as any
export const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};
const Index = () => {
    const history = useHistory();
    const query = useQuery()
    const subjectId = query.get('subjectId')
    const columnId = query.get('columnId')
    const [columnList, setColumnList] = useState([])
    const [currentVideo, setCurrentVideo] = useState({})
    const [recommendList, setRecommendList] = useState([])
    const [codeModal, setCodeModel] = useState(false)
    const [columnInfo, setColumnInfo] = useState({})
    const [loginView, setLoginView] = useState(false)
    const [signupView, setSignView] = useState(false)
    const userInfo: any = store.getState().userInfo
    newWindow.isLogin = () => {
        message.warning({
            content: '请重新登录',
            className: Style.myMessage
        })
        setLoginView(true)
        // clearInterval(newWindow["playing"] as any);
        // watch();
        // 每30秒调用一次接口
        // (newWindow["playing"] as any) = setInterval(() => {
        // //   watch();
        //   // preventOpenMoreVideoFn("1");
        // }, 30000);
    };
    newWindow.isNeedAddBaseInfo = () => {
        message.warning({
            content: '请填写报名信息',
            className: Style.myMessage
        })
        setSignView(true)
    }
    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const initVideo = (current: any) => {
        if (window.createCCH5Player) {
            window.ccPlayerStatus = window.createCCH5Player({
                vid: current.videoUrl,
                siteid: current.ccUserId,
                autoStart: false,
                width: IsPC ? "100%" : "100vw",
                height: "320px",
                watchStartTime: current.videoWatchAt ? current.videoWatchAt : "0",
                playtype: 1,
                rate_allow_change: true,
                parentNode: document.getElementById("livePlayer"),
            });
        }
    };

    const getVideoInfo = () => {
        post('/shop/front/ge/column/getSubjectWatchSectionInfo', {
            subjectId,
            courseId: currentVideo.courseId,
            sectionId: currentVideo.id
        }, false).then(res => {
            setResultInfo({ ...res.data.currentSection, columnId, subjectId, sectionId: res.data.currentSection.id,runStatus:columnInfo.runStatus })
        })
    }
   
    // const getColumnDetail = async () => {
    //    await get('/shop/front/ge/column/subject/getDetail?subjectId=' + subjectId, {}, false).then(res => {
    //         if (res.data) {
    //             setColumnInfo(res.data)
    //             store.dispatch({
    //                 type:"SET_VIDEO_STATUS",
    //                 runStatus:res.data.runStatus
    //             })
    //         }
    //     })
    // }
    // const getColumnList = () => {
    //     post('/shop/front/ge/column/getSubjectCourseSectionList', { subjectId }, false).then(res => {
    //         if (res.data.list.length) {
    //             setColumnList(res.data.list)
    //             setCurrentVideo(res.data.list[0])
    //         }
    //     })
    // }
    const getInitData = async () => {
        const { data } = await get('/shop/front/ge/column/subject/getDetail?subjectId=' + subjectId, {}, false)
        setColumnInfo(data)
        if(data.type===1){
            const data2 = await post('/shop/front/ge/column/subject/content/getList', {
                subjectId,
            }, false)  
            setRecommendList(data2.data.list)
            const res = await post('/shop/front/ge/column/getSubjectCourseSectionList', { subjectId }, false)
            setColumnList(res.data.list)
            setCurrentVideo(res.data.list[0])
        }
    }
    const changeCurrentVideo = (current: any) => {
        setCurrentVideo(current)
    }
    //设置视频缓存信息
    const setResultInfo = (res: any) => {
        let data = { ...res,runStatus:columnInfo.runStatus }
        data.type && delete data.type
        setVideoInfo(data);
    };
    const setVideoInfo = (res: any) => {
        store.dispatch({
            type: "SET_VIDEO_STATUS",
            ...res
        })
        initVideo(res)
    }
    useEffect(() => {
        getInitData()
    }, [])
    useEffect(() => {
        if (currentVideo.id) {
            if (userInfo.userId) {
                getVideoInfo()
            } else {
                setResultInfo({ ...currentVideo, columnId, subjectId, sectionId: currentVideo.id,runStatus:columnInfo.runStatus })
            }
        }
    }, [currentVideo])


    useEffect(() => {
        return () => {
            newWindow.isLogin = null
            newWindow.isNeedAddBaseInfo = null
        }
    }, []);
    const ClassPage = () => {
        const [loading,setLoading] = useState(false)
        return  <List
        itemLayout="horizontal"
        dataSource={columnList}
        loading={loading}
        renderItem={(item: any, index) => (
          <List.Item className="pointer" key={index}>
            <PlayCircleOutlined/> <span className={`plr20 ${currentVideo.id === item.id ? Style.select : ''}`} onClick={()=>{
                changeCurrentVideo(item)
            }}>{item.name}</span> <span className="fr c-999">时长 {item.durationText}</span>
          </List.Item>
        )}
      />
    }
    const RecommendationPage = () => {
        const [list,setList] = useState([])
        const [loading,setLoading] = useState(false)
        const getTuijianList = () => {
            setLoading(true)
            post('/shop/front/ge/column/subject/content/getList', {
                subjectId,
            }, false).then(res => {
                if (res.data.list) {
                    setList(res.data.list)
                }
                setLoading(false)
            }).catch(()=>{
                setLoading(false)
            })
        }
        useEffect(()=>{
            getTuijianList()
        },[])
        return  <List
        itemLayout="horizontal"
        loading={loading}
        dataSource={list}
        renderItem={(item: any, index) => (
          <List.Item className={`pointer ${Style.recommendationItem}`} key={index} onClick={()=>{
            item.titleUrl ? window.location.href = item.titleUrl : history.push(`/recommend/${item.id}?subjectId=${subjectId}`)
          }}>
            <img src={item.logoUrl}  alt=""></img> <span>{item.titleName}</span>
          </List.Item>
        )}
      />
    }
    const items: TabsProps['items'] = columnInfo.type === 1 ? [
        {
            key: '1',
            label: '课程介绍',
            children: <div dangerouslySetInnerHTML={{__html:columnInfo?.content}}></div>
        },
        {
            key: '2',
            label: '课程目录',
            children: <ClassPage/>,
        },
        {
            key: '3',
            label: '内容推荐',
            children: <RecommendationPage/>,
        },
    ] : [
        {
            key: '1',
            label: '课程介绍',
            children: <div dangerouslySetInnerHTML={{__html:columnInfo?.content}}></div>
        }
    ];
    
    const onChange = () => {
    }
    const getLinkProject = () => {
        post('/shop/front/activity/project/watch/info/'+columnInfo.projectId,{},false).then(res=>{
           if(res.code === 0){
            window.location.href = res.data.pcWatchUrl
           }
        }).catch(res=>{
            if(res.code === 101){
                message.warning({
                    content: '请重新登录',
                    className: Style.myMessage
                })
                setLoginView(true)
            }
        })
    }
    return (
        <>
            <div
                className={Style.wrapper}
            >
                <div className="c-bg-fff ptb80 plr40 flex " style={{ width: "100%" }}>
                    {columnInfo.type===1 ? <div className={Style.livePlayer} id="livePlayer" ></div> : <img className={Style.logo} src={columnInfo.logoUrl} alt=""/>}
                    <div className="plr80 ptb80 flex1">
                        <p className="c-999">{columnInfo.parentColumnInfo?.titleName} 第<span className="fs24">{columnInfo.orderNum}</span>期</p>
                        <h3>{columnInfo.titleName}</h3>
                        <p className="ptb80">加入专属交流社群<QrcodeOutlined className="fs24 ml40" onClick={() => setCodeModel(true)} /></p>
                        {columnInfo.type===1 ? <Button type="primary" onClick={() => {
                            window.ccPlayerStatus.play()
                        }}>报名观看</Button> : <Button type="primary" onClick={()=>{
                            getLinkProject()
                        }}>立即学习</Button>}
                        <p className="ptb40">开放时间：{moment(columnInfo.openTimeBegin).format('YYYY-MM-DD')} - {moment(columnInfo.openTimeEnd).format('YYYY-MM-DD')}</p>
                    </div>
                </div>
                <div className="mtb40 c-bg-fff ptb40 plr40 ">
                    <Tabs className={Style.myTabs} defaultActiveKey="1" items={items} onChange={onChange}></Tabs>
                </div>
            </div>
            <Modal open={codeModal} destroyOnClose zIndex="9999" onCancel={() => {
                setCodeModel(false)
            }} footer={null}>
                <div style={{ display: "flex", justifyContent: "center", flexDirection:"column", alignItems: "center", padding: "60px" }}>
                    <img style={{ display: "block", width: "200px", height: "200px" }} src={columnInfo.qrCodeUrl} alt=""></img>
                    <p style={{marginTop:"20px"}} dangerouslySetInnerHTML={{__html:columnInfo.qrCodeContent}}></p>
                </div>
            </Modal>
            <Login open={loginView} onOk={() => {
                if(columnInfo.type === 1) window.ccPlayerStatus.play()
            }} onCancel={() => setLoginView(false)}></Login>
            {userInfo.userId && <SignUp open={signupView} onOk={() => {
                if(columnInfo.type === 1) window.ccPlayerStatus.play()
            }} onCancel={() => setSignView(false)}></SignUp>}
        </>
    );
};

export default Index;
